import OralExam from './OralExam'
export default OralExam
